import { AnimatePresence, motion } from 'motion/react';
import { useFormContext } from 'react-hook-form';
import { useQuestionnaireContext } from '../../context/QuestionnaireContext';
import { isQuestion } from '../../schemas/questionnaire-schema';

export const DeselectDisplay = () => {
  const { state } = useQuestionnaireContext();
  const { getValues, setValue, clearErrors } = useFormContext();

  const { currentQuestionIndex, questions } = state;
  const question = questions[currentQuestionIndex];

  if (!question || !isQuestion(question) || question.questionType !== 'multiselect') {
    return null;
  }

  // Get the current question's value
  const currentValue = getValues(question.slug);

  // Check if current question has a value that can be deselected
  const hasSelectableValue = Array.isArray(currentValue) && currentValue.length > 0;

  const handleDeselectAll = () => {
    setValue(question.slug, []);
    clearErrors(question.slug);
  };

  if (!hasSelectableValue) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -10 }}
        transition={{ duration: 0.2 }}
        className="deselect-display"
        style={{ pointerEvents: 'auto' }}
      >
        <button onClick={handleDeselectAll} className="deselect-display-button">
          Deselect all
        </button>
      </motion.div>
    </AnimatePresence>
  );
};
